import { roleHasPermission } from './permissions.ts';

// Who may create projects/boards is set on the Roles & Access screen ("project.create").
// Shared by the API (enforcement) and the UI (hiding buttons).
export function canCreateProject(role?: string | null): boolean {
  return roleHasPermission(role, 'project.create');
}
